import { RenewalFormTranslations } from '../types';

export const renewalForm: RenewalFormTranslations = {
  title: "Renouvellement d'Inscription 2026/2027",
  subtitle: "Réservez la place de votre enfant pour la prochaine année scolaire. La période de renouvellement est ouverte jusqu'au 17 mars.",
  earlyBirdActive: "🎉 Profitez de la réduction de réservation anticipée! Réservez avant le 23 février et économisez 50€ par enfant sur l'inscription.",
  earlyBirdEnded: "La période de réduction de réservation anticipée est terminée (23 février).",
  contactInfo: "Coordonnées",
  childrenInfo: "Enfants à Inscrire",
  paymentPreference: "Préférence de Paiement",
  optionalServices: "Services Supplémentaires d'Intérêt",
  educationalCommitment: "Engagement Éducatif",
  pricingSummary: "Résumé des Coûts",
  parentName: "Nom du Père/Mère/Tuteur",
  email: "E-mail",
  phone: "Téléphone",
  childName: "Nom de l'Enfant",
  birthDate: "Date de Naissance",
  currentLevel: "Niveau Actuel",
  renewalLevel: "Niveau pour 2026/2027",
  isCurrentStudent: "Cet enfant est actuellement inscrit à Gándara",
  isCurrentStudentHelper: "Décochez cette case s'il s'agit d'un nouveau frère/sœur qui n'est pas actuellement au centre",
  comments: "Commentaires ou Questions",
  commentsPlaceholder: "Avez-vous des questions ou des circonstances particulières que vous aimeriez partager avec nous?",
  levels: {
    infantil3: "Maternelle 3 ans",
    infantil4: "Maternelle 4 ans",
    infantil5: "Maternelle 5 ans",
    primary1: "Primaire - 1ère année",
    primary2: "Primaire - 2ème année",
    primary3: "Primaire - 3ème année",
    primary4: "Primaire - 4ème année",
    primary5: "Primaire - 5ème année",
    primary6: "Primaire - 6ème année",
    infantil: "Maternelle (3 à 6 ans)",
    primary: "Primaire C1 (6 à 8 ans)",
    primaryC2: "Primaire C2 (9 à 11 ans)"
  },
  paymentMonthly: "Paiement Mensuel (10 paiements)",
  paymentAnnual: "Paiement Annuel (1 paiement)",
  annualSavings: "Économisez 200€ par enfant avec le paiement annuel",
  transport: "Transport",
  transportPricing: "225€/mois aller-retour (minimum 4 places)",
  comedor: "Cantine",
  comedorPricing: "195€/mois 5 jours · 125€ 3 jours · 90€ 2 jours · 15€ à la journée",
  aulaMadruga: "Accueil du Matin",
  aulaMadrugaPricing: "75€/mois par famille (à partir de 8h15)",
  servicesNote: "Les prix indiqués sont informatifs. L'inscription aux services supplémentaires est gérée séparément.",
  commitmentTitle: "Engagement Éducatif 2026/2027",
  commitmentText: `Les personnes soussignées déclarent que la relation famille - école sera régie par un esprit de collaboration mutuelle et de confiance afin de contribuer et d'intervenir conjointement dans l'éducation et la formation des enfants. Et à cette fin, elles déclarent savoir que :

1. Gándara International School (GIS) est un établissement d'enseignement étranger, autorisé par la Xunta de Galicia et accrédité comme école internationale par la NEASC (New England Association of Schools and Colleges) pour le deuxième cycle de l'Éducation Infantile et pour l'étape de l'Éducation Primaire. Son offre est l'enseignement privé dans son centre de Gondomar, situé Lugar de Moureira, numéro 1, paroisse de Mañufe, et basé sur une pédagogie active et expérientielle.

2. La durée du présent engagement comprend l'année scolaire 2026/2027, commençant ladite année le 1er septembre 2026. Cette durée pourra faire l'objet d'un RENOUVELLEMENT annuel lorsque s'ouvrira le processus de réservation de place, à condition qu'il existe un consentement exprès et écrit accordé par les parents de l'enfant et par le Centre lui-même.

3. Le programme et le plan d'études du centre seront régis par le Calendrier Scolaire de la Communauté Autonome de Galice.

4. Le Centre sera régi par les Règles du Plan de Cohabitation, du Plan de Protection du Mineur, du Règlement de Régime Intérieur et des autres politiques internes du centre.

5. Les familles devront transmettre des informations véridiques et complètes sur l'enfant durant le processus d'admission, notamment en ce qui concerne la santé, les allergies, les intolérances et toute information pouvant être pertinente pour un développement adéquat du mineur.

6. Le centre ne disposant pas d'une équipe multidisciplinaire pour ACNEAE, au cas où ces NEAE surgiraient, les parents/tuteurs s'engagent à fournir une évaluation externe avec des spécialistes appropriés et/ou un soutien spécifique au moyen de thérapies externes. De même, les diagnostics, traitements et rapports émis par les thérapeutes externes devront être transmis au centre afin de pouvoir travailler en collaboration avec ces cabinets et d'obtenir des évolutions favorables. Le centre se réserve le droit de ne pas être d'accord avec la ligne pédagogique suivie par le cabinet choisi par les parents/tuteurs.

7. En cas de non-respect de cet engagement ainsi que des autres règles publiées sur le site web du centre et à la disposition de tous les parents/tuteurs, celui-ci pourra être résolu par le Centre, avec la possibilité de ne pas renouveler la place pour l'année suivante et/ou d'adopter les mesures expressément prévues dans chaque cas.`,
  commitmentAccept: "J'ai lu et j'accepte l'Engagement Éducatif pour l'année scolaire 2026/2027",
  privacyAccept: "J'ai lu les informations sur la protection des données",
  summaryTitle: "Votre Résumé des Coûts",
  summaryMatricula: "Inscription",
  summaryMonthly: "Mensuel",
  summaryAnnual: "Annuel",
  summaryEarlyBird: "Réduction inscription anticipée",
  summaryAnnualDiscount: "Réduction paiement annuel",
  summaryTotal: "Total Annuel (10 mois)",
  summaryGrandTotal: "TOTAL À PAYER",
  summaryNote: "Les services supplémentaires ne sont pas inclus dans le total",
  summaryPerMonth: "x 10 mois",
  summaryPerYear: "année",
  // Payment timing clarity
  summaryPayNow: "À Payer Maintenant (virement bancaire)",
  summaryBankTransferNote: "Effectuer le virement en août avant la rentrée scolaire",
  summaryPayDuringYear: "Paiements Pendant l'Année Scolaire",
  summaryMonthlyPayments: "Mensualités (sept-juin)",
  summaryMonthlyBreakdown: "10 paiements mensuels de septembre à juin",
  summaryPayAnnual: "Paiement Annuel (septembre)",
  summaryAnnualBase: "Total annuel",
  summaryAnnualTotal: "Total avec réduction",
  summaryAnnualNote: "Paiement unique en septembre",
  siblingLabels: {
    first: "1er frère/sœur",
    second: "2ème frère/sœur",
    third: "3ème+ frère/sœur"
  },
  addChild: "Ajouter un Autre Enfant",
  removeChild: "Supprimer",
  submit: "Confirmer le Renouvellement",
  submitting: "Envoi en cours...",
  success: "Renouvellement confirmé! Redirection vers la page de confirmation...",
  error: "Erreur lors de l'envoi du renouvellement. Veuillez réessayer ou nous contacter.",
  suggestedLevel: "En fonction de la date de naissance, nous suggérons le niveau:",
  allChildrenNewWarning: "Vous avez marqué tous les enfants comme nouveaux élèves. Est-ce correct? Les nouveaux élèves ont des prix différents de ceux du renouvellement.",
  required: "Ce champ est obligatoire",
  invalidEmail: "L'e-mail n'est pas valide",
  invalidPhone: "Le téléphone doit avoir au moins 9 chiffres",
  invalidDate: "La date n'est pas valide",
  futureDateError: "La date de naissance ne peut pas être dans le futur",
  oldDateWarning: "Cette date suggère un âge de {age} ans. Veuillez confirmer que c'est correct.",
  atLeastOneChild: "Vous devez ajouter au moins un enfant"
};
